export const handleProfileNavigate = (navigate, currentUserId) => (targetUserId) => {

    // Add validation and debugging
    if (!targetUserId) {
        console.warn("targetUserId is undefined - cannot navigate to profile");
        return;
    }

    if (!currentUserId) {
        console.warn("currentUserId is undefined - navigating to account page");
        navigate("/account");
        return;
    }

    if (targetUserId !== currentUserId) {
        navigate(`/account/${targetUserId}`);
    } else {
        navigate("/account");
    }
};